import React, { use, useState, useContext } from "react";
import { loginUser } from "../services/authRequests";
import { AuthContext } from "../contexts/AuthContext";
import { toast } from "react-toastify";
import {
  FacebookLoginButton,
  GoogleLoginButton,
} from "react-social-login-buttons";
import RegistrationForm from "./RegistrationForm";
import ForgotPasswordModal from "./ForgotPassword";
import { useCart } from "../contexts/CartContext";
import { BASE_URL } from "../utils/constants";
import { HeadCircuit } from "@phosphor-icons/react";
const LoginSignUp = () => {
  document.title = "Login or Sign Up | Bigmall";
  const { login } = useContext(AuthContext);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const { clearCartItemsLogin } = useCart();
  //const [rememberMe, setRememberMe] = useState(false);
  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };
  const handleGoogleLogin = () => {
    localStorage.setItem("clearCartAfterLogin", "true");
    window.location.href = `${BASE_URL}/oauth2/authorization/google`; // Redirect to backend for OAuth2 login
  };
  const handleFacebookLogin = () => {
    localStorage.setItem("clearCartAfterLogin", "true");
    window.location.href = `${BASE_URL}/oauth2/authorization/facebook`; // Redirect to backend for OAuth2 login
  };

  //const [error, setError] = useState("");
  const handleLogin = async (event) => {
    event.preventDefault();
    try {
      const res = await loginUser(email, password);
      // console.log(res);
      login(res); // Update AuthContext with login data
      //alert("Login successful.");
      clearCartItemsLogin();
      window.location.reload();
    } catch (error) {
      toast.error(error.response?.data?.message || "Login failed.");
    }
  };
  return (
    <section className="account py-20">
      <div className="container container-lg">
        {/* <form action="#"> */}
        <div className="row gy-4">
          {/* Login Card Start */}
          <div className="col-xl-6 pe-xl-5">
            <div className="border border-gray-100 hover-border-main-600 transition-1 rounded-16 px-24 py-10 h-100">
              <h6 className="text-sm mb-10">Login</h6>
              <form onSubmit={handleLogin}>
                <div className="mb-10 ">
                  <label
                    htmlFor="email"
                    className="text-neutral-900 text-sm mb-8 fw-semibold"
                  >
                    Email <span className="text-danger">*</span>{" "}
                  </label>
                  <input
                    type="text"
                    className="common-input-two text-sm"
                    id="email"
                    placeholder="Email"
                    onChange={(e) => setEmail(e.target.value)}
                    value={email}
                    required
                  />
                </div>
                <div className="mb-10">
                  <label
                    htmlFor="password"
                    className="text-neutral-900 text-sm mb-8 fw-semibold"
                  >
                    Password
                  </label>
                  <div className="position-relative">
                    <input
                      type={showPassword ? "text" : "password"}
                      className="common-input-two text-sm"
                      id="password"
                      placeholder="Enter Password"
                      onChange={(e) => setPassword(e.target.value)}
                      value={password}
                      required
                    />
                    <span
                      className="toggle-password position-absolute top-50 inset-inline-end-0 me-16 translate-middle-y cursor-pointer text-sm"
                      id="togglePasswordtwo"
                      onClick={toggleShowPassword}
                    >
                      {showPassword ? "Hide" : "Show"}
                    </span>
                  </div>
                </div>
                <div className="mb-10 mt-10">
                  <div className="flex-align gap-48 flex-wrap">
                    <button type="submit" className="btn btn-main btn-sm">
                      Log in
                    </button>
                    {/* <div className="form-check common-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={rememberMe}
                        onChange={() => setRememberMe(!rememberMe)}
                        id="remember"
                      />
                      <label
                        className="form-check-label flex-grow-1"
                        htmlFor="remember"
                      >
                        Remember me
                      </label>
                    </div> */}
                  </div>
                </div>
              </form>
              <div>
                <button
                  className="text-danger-600 text-sm fw-semibold hover:underline bg-transparent border-none cursor-pointer"
                  onClick={() => setModalOpen(true)}
                >
                  Forgot your password?
                </button>
              </div>

              <ForgotPasswordModal
                isOpen={isModalOpen}
                onClose={() => setModalOpen(false)}
              />
              <div className="text-sm  mt-10 mb-10">
                Or, login with
              </div>
              <div className="mt-10 d-flex flex-row flex-sm-row align-items-center gap-8">
                <button onClick={handleGoogleLogin}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 48 48"
                    width="22px"
                    height="22px"
                  >
                    <path
                      fill="#4280EF"
                      d="M42.462 24.212a23.57 23.57 0 0 0-.329-3.817h-17.77v7.264h10.178a8.562 8.562 0 0 1-3.775 5.705l6.073 4.72c3.57-3.325 5.623-8.168 5.623-13.872"
                      data-spm-anchor-id="a2a0e.tm80335410.0.i0.675a4cee0YDUZD"
                    ></path>
                    <path
                      fill="#34A353"
                      d="M24.365 42.597c5.09 0 9.357-1.683 12.476-4.556l-6.074-4.678c-1.682 1.149-3.857 1.806-6.402 1.806-4.924 0-9.07-3.324-10.588-7.757L7.54 32.214a18.818 18.818 0 0 0 16.825 10.383"
                    ></path>
                    <path
                      fill="#F6B704"
                      d="M13.777 27.371c-.78-2.339-.78-4.883 0-7.223l-6.238-4.842c-2.667 5.335-2.667 11.614 0 16.908z"
                    ></path>
                    <path
                      fill="#E54335"
                      d="M24.365 12.393a10.277 10.277 0 0 1 7.223 2.832l5.376-5.418c-3.406-3.2-7.92-4.924-12.599-4.883A18.818 18.818 0 0 0 7.54 15.307l6.237 4.842c1.519-4.473 5.664-7.756 10.588-7.756"
                    ></path>
                  </svg>
                  <span>Google</span>
                </button>
                <button onClick={handleFacebookLogin}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 48 48"
                    width="22px"
                    height="22px"
                  >
                    <path
                      fill="#1877F2"
                      d="M47.385 24.143C47.385 11.149 36.915.615 24 .615 11.085.615.615 11.15.615 24.143c0 11.743 8.552 21.477 19.731 23.242V30.944H14.41v-6.801h5.937V18.96c0-5.897 3.491-9.154 8.833-9.154 2.559 0 5.235.46 5.235.46v5.79h-2.95c-2.904 0-3.81 1.813-3.81 3.674v4.413h6.485l-1.036 6.8h-5.45v16.442c11.18-1.765 19.732-11.498 19.732-23.242"
                    ></path>
                  </svg>
                  <span>Facebook</span>
                </button>
              </div>
            </div>
            <div></div>
          </div>
          <div className="col-xl-6">
            <RegistrationForm />
          </div>
        </div>
      </div>
    </section>
  );
};

export default LoginSignUp;
